import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Project } from '../entities/ProjectEntity';

interface ProjectProps {
    project: Project;
}

export default function ProjectCard(props: ProjectProps) {
    const project = props.project;
    return (
        <Card sx={{ width: '20em', height: '15em', margin: '0.25em' }}>
            <CardContent sx={{ height: '10em' }}>
                <Typography gutterBottom variant="h5" component="div">
                    {project.name}
                </Typography>
                <Typography variant="body2" sx={{
                    height: '10em', color: 'text.secondary', overflow: "hidden",
                    overflowY: "scroll"
                }}>
                    {project.description}
                </Typography>
            </CardContent>
            <CardActions>
                <Button onClick={() => {
                    window.open(project.html_url, "_blank")
                }} size="small" sx={{ marginTop: '2.5em', marginLeft: '0.5em' }}>Open</Button>
            </CardActions>
        </Card>
    );
}
